/* Hotel Service Menu */
import Vue from "vue"

const pool = new Vue({
  data: {
    timeout: null,
    value: ""
  }
})

const HSM = {
  install(Vue) {
    Vue.prototype.$hotelServiceMenu = function(event) {
      if (pool.timeout) _$.removeTimeout(pool.timeout)
      if (pool.value.length > 24) return (pool.value = "")

      const P_KEY = window.P_KEY
      let timeout = 1000
      pool.value += event.keyCode.toString()

      switch (pool.value) {
        case `${P_KEY.settings}${P_KEY.left}${P_KEY.left}${P_KEY.right}${P_KEY.right}${P_KEY.settings}`:
        case `${P_KEY.info}${P_KEY.left}${P_KEY.left}${P_KEY.right}${P_KEY.right}${P_KEY.info}`:
        case `10385${P_KEY.left}${P_KEY.left}${P_KEY.right}${P_KEY.right}10385`:
          __.hsm.show()
          pool.value = ""
          break
      }

      pool.timeout = _$.makeTimeout(() => (pool.value = ""), timeout)
    }
  }
}

export default HSM
